<template>
<v-row>
    <v-col>
        <v-row v-if="lastUpdate" class="pl-12 pt-4" dense justify="center" test-id="last-update-section">
            <v-col class="text-center pt-4" style="border-top: 1px solid var(--card-border)">
                <span class="cts-font-size-3 cts-color-tertiary font-italic">
                    {{ $vuetify.lang.t('$vuetify.lastUpdate') }}:
                    {{ lastUpdate.format(const_global.DATE_TIME_FORMAT_A) }}
                </span>
            </v-col>
        </v-row>
        <v-row dense justify="center">
            <v-btn test-id="transaction-update-button" :loading="loadingUpdate" color="var(--primary-alternative)" text @click="handleUpdate">
                <v-icon>refresh</v-icon>
                {{ $vuetify.lang.t('$vuetify.update') }}
            </v-btn>
        </v-row>
    </v-col>
</v-row>
</template>
<script>
import const_global from "@/constants/global";
export default {
    name: "TransactionDetailUpdateSection",
    data() {
        return {
            const_global,
            loadingUpdate: false, 
        };
    },
    props: {
        transaction_content: Object,
        getTransactionData: Function,
        const_permissions: Object,
        checkPermission: Function,
        lastUpdate: Object,
    },
    methods: {
        async handleUpdate() {
            this.loadingUpdate = true;
            await this.getTransactionData();
            setTimeout(() => {
                this.loadingUpdate = false;
            }, 2000);
        },
    },
};
</script>